import React from 'react';
import { Icon } from '@design-manager-inc/ui';
import type { TMoodBoardStatuses } from 'api/resources/moodBoards';
import {
	isMoodBoardStatusApproved,
	isMoodBoardStatusRejected,
} from 'api/resources/moodBoards';

interface IMoodBoardStatusProps {
	status: TMoodBoardStatuses;
}

export const MoodBoardStatus = ({ status }: IMoodBoardStatusProps) => {
	// Tinted icon + label, the same treatment `InvoiceCard` gives "Paid".
	if (isMoodBoardStatusApproved(status)) {
		return (
			<span className="text-sm flex flex-row items-center gap-2 h-full mr-2">
				<div className="text-green-800 flex flex-row items-center gap-1">
					<Icon name="check-circle" className="fill-green-800" />
					<span>Approved</span>
				</div>
			</span>
		);
	}

	if (isMoodBoardStatusRejected(status)) {
		return (
			<span className="text-sm flex flex-row items-center gap-2 h-full mr-2">
				<div className="text-red-800 flex flex-row items-center gap-1">
					<Icon name="x-circle" className="fill-red-800" />
					<span>Rejected</span>
				</div>
			</span>
		);
	}

	return (
		<span className="text-sm flex flex-row items-center gap-2 h-full mr-2 whitespace-nowrap">
			<div className="text-gray-500 flex flex-row items-center gap-1">
				<Icon name="clock" className="fill-gray-500" />
				<span>Pending Review</span>
			</div>
		</span>
	);
};

MoodBoardStatus.displayName = 'MoodBoardStatus';
